import { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { useSignedIn } from '../../session.js';
import { sendAllPending } from './data.js';
import { NewProject } from './NewProject.js';
import { DeleteProject, DuplicateProject } from './ProjectDialogs.js';
import { RoiList } from './RoiList.js';
import { RoiProject } from './RoiProject.js';

/**
 * ROI module (brief section 7.7), mounted at /roi/*: the list, New project
 * (a window over the list), and each project with its Delete and Duplicate
 * windows, and Show to client. Every window has its own address, so Back
 * closes it first.
 */
export function RoiScreen() {
  const { user } = useSignedIn();

  // Changes kept on this device go as soon as the ROI opens and when the network returns.
  useEffect(() => {
    const send = () => void sendAllPending(user.id).catch(() => undefined);
    send();
    window.addEventListener('online', send);
    return () => window.removeEventListener('online', send);
  }, [user.id]);

  return (
    <Routes>
      <Route element={<RoiList />}>
        <Route index element={null} />
        <Route path="new" element={<NewProject />} />
      </Route>
      {/* Show to client has its own address, so Back leaves it. */}
      <Route path=":id/present" element={<RoiProject present />} />
      <Route path=":id" element={<RoiProject />}>
        <Route index element={null} />
        <Route path="delete" element={<DeleteProject />} />
        <Route path="duplicate" element={<DuplicateProject />} />
      </Route>
    </Routes>
  );
}
